import { render, staticRenderFns } from "./EventStatTableCard.vue?vue&type=template&id=760cf923&"
import script from "./EventStatTableCard.vue?vue&type=script&lang=ts&"
export * from "./EventStatTableCard.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports